import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {  Button,  Select,  DatePicker, Popconfirm,message } from 'antd';
import { ADMIN_API_BASE_ENDPOINT,PER_PAGE_DATA, AWS_S3_URL, ONLY_DATE_FORMAT, GOOGLE_MAP_KEY } from 'configs/AppConfig';
import service from 'auth/FetchInterceptor';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
const moment = require('moment');
const { RangePicker } = DatePicker;
const { Option } = Select ;

class Attendance extends Component {
    constructor(props) {
        super(props);

		this.state = {
			attendanceData: [],
    		loading: true,
            cust_lat: '23.006213',
            cust_lng :'72.5559658',
            cust_address : 'Nilkanth Plaza, Freniben Desai Marg, Near Sahajand Plaza, Bhatta, Paldi, Ahmedabad, Gujarat 380007, India'


		}
	}

    componentDidMount(){
        // this.fetchAttendanceData();
        this.getLocation();
        this.setState({
			attendanceData: this.props.attendanceData,
		});

    }

	fetchAttendanceData = async () => {

		await service.get(ADMIN_API_BASE_ENDPOINT + 'attendance/get', {}).then((response) => {
			this.setState({
				attendanceData: response.attendance_Data,
				loading: false,
			});
		});
	}

    getLocation = () => {
        if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(position => {
				const { latitude, longitude } = position.coords;

                this.setState({
                    cust_lat :latitude,
                    cust_lng : longitude
                })

				this.fetchCurrentAddress(latitude, longitude);
				},
				(error) => {
				if (error.code === error.PERMISSION_DENIED) {
					console.log("User denied the request for Geolocation.");
				}
			});
		}
    }

    fetchCurrentAddress = (lat, lng) => {
        const geocoder = new window.google.maps.Geocoder();
        const location = { lat, lng };

        geocoder.geocode({ location }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              this.setState({ cust_address: results[0].formatted_address });
            } else {
              console.error('No results found');
            }
          } else {
            console.error('Geocoder failed due to: ' + status);
          }
        });
    }

    checkInStaff = async() => {

        const { cust_lat, cust_lng, cust_address } =this.state;

        // Check if lat, lng, and address are set
        if (!cust_lat || !cust_lng || !cust_address) {
            message.error("Location information is missing.")
            this.getLocation(); // Try to fetch location again
            return; // Exit check-in if location data is missing
        }

        const requestParam = {
			latitude: cust_lat,
			longitude: cust_lng,
			location: cust_address,
		}

        await service.post(ADMIN_API_BASE_ENDPOINT + 'attendance/checkin', requestParam ).then((response) => {

            if(response.code == 200){
                message.success(response.success);
                this.fetchAttendanceData();
            }

            this.setState({
				loading: false,
			});
		});
    }

    checkOutStaff = async() => {

        const formData = new FormData();
        const { cust_lat, cust_lng, cust_address } =this.state;

        // Check if lat, lng, and address are set
        if (!cust_lat || !cust_lng || !cust_address) {
            message.error("Location information is missing.")
            this.getLocation(); // Try to fetch location again
            return; // Exit check-in if location data is missing
        }

        formData.append('latitude', cust_lat);
        formData.append('longitude', cust_lng );
        formData.append('location', cust_address );

        await service.post(ADMIN_API_BASE_ENDPOINT + 'attendance/checkout', formData).then((response) => {

            if(response.code == 200){
                message.success(response.success);
                this.fetchAttendanceData();
            }
            this.setState({
				loading: false,
			});
		});

    }



    render() {
        const attendanceData = this.state.attendanceData;
        const userData = JSON.parse(localStorage.getItem('userData'));

        var role_name = userData.role_id !== undefined && userData.role_id.length > 0 ? userData.role_id[0].role_name : "";
        return (

            <div>
                {
                   role_name && role_name !== 'Main Admin' ?
                   <>
                        {
                    attendanceData.length == 0 &&
                    <Popconfirm title="Are you sure to sign in？" okText="Yes" cancelText="No" onConfirm={()=>{this.checkInStaff()}} >
                    <Button type="primary">CONFIRM ATTENDANCE </Button>
                    </Popconfirm>
                    }
                    {
                    attendanceData.length > 0 &&  attendanceData[0].check_in == 'yes' && attendanceData[0].check_out == 'no' ?
                    <Popconfirm title="Are you sure to sign out?" okText="Yes" cancelText="No" onConfirm={()=>{this.checkOutStaff()}} >
                    <Button type="primary">CONFIRM LEAVE</Button>
                    </Popconfirm>
                    :
                    null
                    }
                   </>
                   :
                   null
                }


            </div>
        );
    }
}


export default withRouter(GoogleApiWrapper({
    apiKey: GOOGLE_MAP_KEY
  })(Attendance));
